// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PawPrintIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M26.5 10a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM9 13.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0ZM5.5 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm6-4a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm9 5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2.89 12.608a4.413 4.413 0 0 1-2.109-2.643 5.5 5.5 0 0 0-10.562 0 4.406 4.406 0 0 1-2.094 2.637 5 5 0 0 0 4.315 9.007 8.01 8.01 0 0 1 6.109 0 5 5 0 0 0 4.341-9v-.002ZM21 26a3 3 0 0 1-1.181-.241 10.017 10.017 0 0 0-7.649 0 3 3 0 0 1-2.589-5.408 6.404 6.404 0 0 0 3.058-3.834 3.5 3.5 0 0 1 6.722 0 6.408 6.408 0 0 0 3.066 3.84A3 3 0 0 1 21 26Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
